import Global from './Global';

const BASE_URL = 'wss://bot.newsfeedapps.com';
// const BASE_URL = 'ws://192.168.1.124:3004/';

let client = null;
let room = null;

function initColyseus() {
  client = new Colyseus.Client(BASE_URL);
}

function sendGameTick() {
  if (!room) return false;

  room.send('game_tick', {
    message: 'tick',
  });
}

const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 1000; // 1 second between retries
let retryCount = 0;
let connectStatus = '';
async function createRoomWithRetry() {
  try {
    room = await client.create('gameRoom', {
      gameID: String(Global.gameID),
      playerIndex: parseInt(Global.playerIndex),
      playerName: String(Global.playerName),
      collectableType: String(Global.collectableType),
      _cacheBuster: Date.now(),
    });
    Global.roomID = room.id;
    connectStatus = 'success';
    onRoomCreated();
    return room;
  } catch (err) {
    if (err.code == -1) {
      connectStatus = 'failure';
    }

    if (retryCount < MAX_RETRIES) {
      retryCount++;
      console.log(
        `Attempt ${retryCount} failed. Retrying in ${RETRY_DELAY_MS}ms...`
      );
      await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS));
      return createRoomWithRetry();
    } else {
      console.error('Max retries reached. Failed to create room.');
      throw err; // Re-throw the error after all retries fail
    }
  }
}

async function connect() {
  try {
    let roomIdToJoin = -1;
    let rooms = [];
    connectStatus = '';
    if (Global.playerIndex == 1) {
      try {
        retryCount = 0;
        room = await createRoomWithRetry();
      } catch (finalError) {
        console.error('Final error after retries:', finalError);
        // Handle the final failure case here
      }

      // try {
      //   room = await client.create('gameRoom', {
      //     gameID: String(Global.gameID),
      //     playerIndex: parseInt(Global.playerIndex),
      //     playerName: String(Global.playerName),
      //     collectableType: String(Global.collectableType),
      //     _cacheBuster: Date.now(), // Add this line
      //   });
      //   Global.roomID = room.id;
      //   connectStatus = 'success';
      //   onRoomCreated();
      // } catch (err) {
      //   if (err.code == -1) {
      //     connectStatus = 'failure';
      //   }
      // }
    } else {
      if (Global.roomID != null) {
        try {
          room = await client.joinById(Global.roomID, {
            playerIndex: parseInt(Global.playerIndex),
            playerName: String(Global.playerName),
            collectableType: String(Global.collectableType),
            _cacheBuster: Date.now(), // Add this line
          });
          connectStatus = 'success';
          onRoomCreated();
        } catch (err) {
          if (err.code == -1) {
            connectStatus = 'failure';
          }
        }
      } else {
        try {
          rooms = await client.getAvailableRooms('gameRoom');
        } catch (err) {}
        rooms.forEach(async (roomInst) => {
          if (String(roomInst.metadata.gameID) == String(Global.gameID)) {
            roomIdToJoin = roomInst.roomId;
          }
        });
        if (roomIdToJoin !== -1) {
          try {
            room = await client.joinById(roomIdToJoin, {
              playerIndex: parseInt(Global.playerIndex),
              playerName: String(Global.playerName),
              collectableType: String(Global.collectableType),
            });
            connectStatus = 'success';
            onRoomCreated();
          } catch (err) {
            if (err.code == -1) {
              connectStatus = 'failure';
            }
          }
        } else {
          connectStatus = 'failure';
        }
      }
    }
  } catch (err) {
    if (err.code == -1) {
      connectStatus = 'failure';
    }
  }
  return connectStatus;
}
function destroyGameRoom() {
  room && room.removeAllListeners();
  room && room.leave(true);

  room = null;
}
function onRoomCreated() {
  room &&
    room.onMessage('*', (type, data) => {
      if (type == 'Actions') {
        onActions(data);
      } else if (type == 'Game') {
        onGameEvents(data);
      }
    });

  room && room.onLeave(onLeave);
  if (room) {
    Global.gameTick = setInterval(sendGameTick, 5000);
    window.gameRoom = room;
  }
  window.addEventListener('unload', () => {
    if (client && room) {
      room
        .leave()
        .catch((err) => console.error('Failed to leave the room:', err));
    }
  });
}
async function onLeave() {
  if (!room) return false;

  Global.gameTick && clearInterval(Global.gameTick);

  if (Global.gameFinished) return false;

  try {
    room = await client.reconnect(room.id, room.sessionId);
  } catch (err) {
    console.log(err);
  }
  onRoomCreated();
}

function sendEvents(data) {
  if (!room) return false;

  room.send('game_events', data);
}

function sendActions(actionType, actionData, robotType) {
  if (!room) return false;

  room.send('action', {
    actionType,
    actionData,
  });
}

function onActions(data) {
  switch (data.message.actionType) {
    case 'cookie_collected':
      Global.events.dispatchEvent({
        type: 'GAME_EVENTS',
        message: {
          event_type: 'remove_opponent_cookie',
          data: {
            cookieIndex: data.message.actionData.itemIndex,
            opponentScore: data.message.actionData.opponentScore,
          },
        },
      });
      break;
    case 'volume_action':
      Global.soundEnabled = data.message.actionData.volume != 0;
      if (Global.soundEnabled) {
        Global.bgAudio.resume();
      } else {
        Global.bgAudio.pause();
      }
      break;
  }
}

function onGameEvents(data) {
  switch (data.message) {
    case 'start_game':
      Global.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'start_game',
          data: {
            initData: data.initData,
          },
        },
      });
      break;
    case 'start_game_timer':
      Global.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'start_game_timer',
          data: {
            initData: data.initData,
          },
        },
      });
      break;
    case 'game_count_down':
      Global.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'game_count_down',
          data: {
            countdown: data.countdown,
          },
        },
      });
      break;
    case 'game_tick':
      Global.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'game_tick',
          data: {
            gameTime: data.gameTime,
          },
        },
      });
      break;
    case 'add_new_cookie':
      Global.events.dispatchEvent({
        type: 'GAME_EVENTS',
        message: {
          event_type: 'add_new_cookie',
          data,
        },
      });
      break;
    case 'game_over':
      // Global.scoreTotal = data['scoreTotal'];
      Global.events.dispatchEvent({
        type: 'GAME_EVENTS',
        message: {
          event_type: 'game_over',
          data,
        },
      });
      break;
    case 'user_left':
      Global.emitter && Global.emitter.emit('user:leave');
      break;
  }
}
export { connect, sendActions, sendEvents, initColyseus, destroyGameRoom };
